/**
 * ShowMore
 * ======================================
 * - tlačítko odkryje další dávku skrytých položek (galerie na mobilu)
 * - po odkrytí všech se tlačítko schová
 */

const BUTTONS = document.querySelectorAll('.js-show-more-button')
const BATCH = 12

BUTTONS.forEach((button) => {
  const list = document.querySelector(button.dataset.target)

  if (!list) {
    return
  }

  button.addEventListener('click', () => {
    const hidden = list.querySelectorAll('.js-show-more-item:not(.is-visible)')

    Array.from(hidden).slice(0, BATCH).forEach((item) => item.classList.add('is-visible'))

    if (hidden.length <= BATCH) {
      button.parentNode.style.display = 'none'
    }
  })
})
